export const sectionConfig = {
  handles: "e, w",
  autoHide: true,
  minWidth: 9,
  classes: {
    "ui-resizable-handle": "ui-resizable-handle section-resizable-handle"
  }
};

